import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  PORTFOLIO_QUERY_KEY,
  PORTFOLIOS_QUERY_KEY,
} from '@/hooks/portfolio/usePortfolio';
import { PORTFOLIO_ANALYSIS_QUERY_KEY } from '@/hooks/portfolio/usePortfolioAnalysis';
import { PORTFOLIOS_PERFORMANCE_TIMESERIES_QUERY_KEY } from '@/hooks/portfolio/usePortfolioPerformanceTimeseries';
import { AGGREGATE_PORTFOLIO_QUERY_KEY } from '@/hooks/portfolio/useAggregatePortfolio';
import type { PortfolioQueryClientData } from '@/hooks/portfolio/usePortfolio';

import { updateManualPortfolioQueryFn } from './updateManualPortfolioQueryFn';

export function useUpdateManualPortfolio() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: updateManualPortfolioQueryFn,
    onSuccess: (portfolio) => {
      queryClient.setQueryData<PortfolioQueryClientData>(
        [PORTFOLIO_QUERY_KEY, portfolio.id],
        () => portfolio
      );
    },
    onSettled: (portfolio, __, { triggerPortfolioTimeSeriesRecalculation }) => {
      queryClient.invalidateQueries({ queryKey: PORTFOLIOS_QUERY_KEY });

      queryClient.invalidateQueries({
        queryKey: AGGREGATE_PORTFOLIO_QUERY_KEY,
      });

      queryClient.invalidateQueries({
        queryKey: [PORTFOLIO_ANALYSIS_QUERY_KEY, portfolio?.id],
      });

      if (triggerPortfolioTimeSeriesRecalculation) {
        queryClient.invalidateQueries({
          queryKey: [
            PORTFOLIOS_PERFORMANCE_TIMESERIES_QUERY_KEY,
            portfolio?.id,
          ],
        });
      }
    },
  });

  return mutation;
}
